<div class="paper-snackbar">
  {{ message }}
  <div *ngFor="let action of actions">
    <button class="action" (click)="activeModal.close(action)">{{ action }}</button>
  </div>
</div>
